// extracted by mini-css-extract-plugin
export default {"container":"H_-z","tab":"I_-z","selected":"J_-z"};